export default [
  { name: 'home', path: '/', redirect: {name: 'calendar-month'} },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: () => import('@web/pages/ExamplePage.vue'),
    meta: { title: 'Dashboard' },
  },
];
